'use client';

import type { ReactElement } from 'react';
import { Ctext } from '../Ctext';
import { TextPreset } from '@/constants/componentPresets';

interface MessageModalFooterNoteProps {
  footerNote?: string;
}

export function MessageModalFooterNote({
  footerNote,
}: MessageModalFooterNoteProps): ReactElement | null {
  if (!footerNote) {
    return null;
  }

  return (
    <Ctext
      preset={TextPreset.Regular}
      size={16}
      align="center"
      opacity={0.8}
    >
      {footerNote}
    </Ctext>
  );
}
